import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-28473-learn-k12-core-curriculum-service-integration',
  ],
  OnComponent,
  OffComponent,
})

export default FlagToggler
